export default __webpack_public_path__ + "static/media/checkGreen.4320e23b.svg";